import { render, staticRenderFns } from "./ModalConsignmentSplit.vue?vue&type=template&id=1baf01e4&"
import script from "./ModalConsignmentSplit.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports